import React,{ useState, useEffect, useRef, useLayoutEffect } from 'react';

const TimelineContextMenu= ({ item,target, options, classes,targetSelected,onSendAction,onOutClick,itemContext}) => {
  const [contextData, setContextData]= useState({ visible:false, posX: 0, posY: 0});
  const [targetSel,setTargetSel] =useState(null);
  const contextRef= useRef(null);
  const [visible,setVisible]=useState(false);
 
  useEffect(() => {
    if(target.id==item.id)
      setVisible(true);

    const offClickHandler= (event) => {
      // console.log("offClickHander");
      onOutClick();
    }

    document.addEventListener('click', offClickHandler)
    return () => {
      document.removeEventListener('click', offClickHandler)
    }
  }, [contextData, item,target,targetSelected])

  const handlerClickItem=(e,option,target,item)=>{
    onSendAction(option.id,itemContext,target,item);
  }
  return (
    <div  ref={contextRef} className='contextMenu' 
    style={{ display:'block', left: target.pos.x, top: target.pos.y }}>
      <div className={`optionsList ${classes?.listWrapper}`}>
        {options.map((option) => (
          <li key={option.id} className={`optionListItem ${classes?.listItem}`} onClick={(e)=>{handlerClickItem(e,option,target,item)}}>
            {option.id!="delete" && option.title}
            {option.id=="delete" && option.title+ " at "+target.date}
          </li>
        ))}
      </div>
    </div>
  );
}

export default TimelineContextMenu;